import React from "react";
import { Phone, ChevronDown } from "lucide-react";

// ── Same static data used in the admin ContactPage ────────────────────────
const LEVELS = [
  {
    level: 1,
    levelLabel: "Customer Relationship Management (CRM)",
    description: "Frontline support for product issues and access questions",
    name: "Pavan Kumar",
    phone: "9353289787",
  },
  {
    level: 2,
    levelLabel: "Senior Support",
    description: "Escalations for unresolved tickets, technical deep-dives",
    name: "MadhuSudhan",
    phone: "9611246848",
  },
  {
    level: 3,
    levelLabel: "Director",
    description: "Final escalation point for major outages or commercial concerns",
    name: "Shrikanth HR",
    phone: "7624915115",
  },
];

function initials(name) {
  return (name || "?")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0].toUpperCase())
    .join("");
}

export default function PortalContactPage() {
  return (
    <div className="page-wrap">
      <div className="page-header">
        <h1 className="page-title">Contact</h1>
        <p className="page-sub">
          Escalation hierarchy — reach out level by level if a ticket isn&apos;t resolved.
        </p>
      </div>

      <div className="hierarchy-stack" data-testid="contact-hierarchy">
        {LEVELS.map((item, idx) => (
          <React.Fragment key={item.level}>
            <div className="hier-row">
              <div className="hier-step-label">
                <span className="hier-step-num">L{item.level}</span>
                <span className="hier-step-title">{item.levelLabel}</span>
              </div>

              <div className="hier-cards">
                <article className="contact-card" data-testid={`contact-l${item.level}`}>
                  <div className="contact-photo-wrap">
                    <span className="contact-photo-fallback">{initials(item.name)}</span>
                  </div>
                  <div className="contact-info">
                    <p className="contact-name">{item.name}</p>
                    <p className="contact-role">{item.levelLabel}</p>
                    <p className="contact-desc">{item.description}</p>
                    <div className="contact-links">
                      <a
                        href={`tel:${item.phone}`}
                        className="contact-link"
                        data-testid={`contact-phone-l${item.level}`}
                      >
                        <Phone size={13} />{item.phone}
                      </a>
                    </div>
                  </div>
                </article>
              </div>
            </div>

            {idx < LEVELS.length - 1 && (
              <div className="hier-arrow" aria-hidden="true">
                <ChevronDown size={20} />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
